var _rect, _path, _rect2, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecisionTreeOperationOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 7,
    width: 14,
    height: 27,
    rx: 3,
    fill: "#272d55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 64V64C94 57.9249 89.0751 53 83 53L29 53C22.9249 53 18 57.9249 18 64V64",
    stroke: "#272d55",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 75,
    width: 14,
    height: 27,
    rx: 3,
    fill: "#272d55"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 75,
    width: 14,
    height: 27,
    rx: 3,
    fill: "#272d55"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 75,
    width: 14,
    height: 27,
    rx: 3,
    fill: "#272d55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64L56 43",
    stroke: "#272d55",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionTreeOperationOutlinedIcon);
export default __webpack_public_path__ + "static/media/DecisionTreeOperationOutlinedIcon.d9a88370e7faba5ab210316854f0b5ff.svg";
export { ForwardRef as ReactComponent };